import { Box, Typography, useTheme } from '@mui/material';
import { useCreateChallenge } from '_api';
import { ChallengePayload } from '_api/types';
import { AdminRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { DefaultNewChallenge } from '_constants/object-templates';
import { TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { ChallengeForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useNavigateTo } from 'utils';
import { useUser } from 'utils/hooks';

export const AddChallenge = () => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const { mutateAsync: createChallenge } = useCreateChallenge();
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { isAdmin } = useUser();

  const onBack = () => {
    navigate(AdminRouteMap.CHALLENGES);
  };

  const onSubmit = (submitChallenge: ChallengePayload) => {
    createChallenge(submitChallenge)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            navigate(AdminRouteMap.LIBRARY);
          }, 1500);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please refresh the page and try again.',
          );
        } else if (error.message) {
          setErrorMessage(`ERROR: ${error.message}`);
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    <Box style={{ padding: 0 }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Add Functional Challenge
        </Typography>
        <TextButton
          onClick={onBack}
          sx={{ color: theme.palette.primary.main, marginBottom: '10px', paddingLeft: 0 }}
        >
          <IoArrowBackOutline />
          BACK
        </TextButton>
      </Box>
      <ChallengeForm
        disableAll={showSuccess}
        initValue={{
          ...DefaultNewChallenge,
          shareWithOrg: isAdmin,
        }}
        onBack={onBack}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Challenge successfully created'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </Box>
  );
};
